module.exports = __webpack_public_path__ + "img/Logo-FEDER-complet.ea9f7489.jpg";